import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router';
import { Badge } from 'reactstrap';
import {
    Row, Card
} from 'reactstrap';
import { H4, LI, P, Image, UL, Btn } from '../../../AbstractElements';
import errorImg from '../../../assets/images/search-not-found.png';
import { useSelector, useDispatch } from 'react-redux';
import { handleDelete } from 'Component/DashboardQeza/Common/DeleteUtils';
import { deleteDoctor } from 'Services/Features/Doctor/Utils/doctorUtils';
import { setFormData } from 'Services/Features/Doctor/doctorSlice';
import Moment from 'react-moment';

const DoctorContent = ({ setRefetch }) => {
    const doctors = useSelector((state) => state.doctor.doctors);
    
    // const currentCategory = useSelector((state) => state.category.currentCategory);
    const dispatch = useDispatch();
    const layoutColumns = 3;
    const history = useNavigate();


    const handleEdit = (item) => {
        console.log(item, 'handleEditItem');
        // Simpan data photos dan profile_picture ke state terpisah
        dispatch(setFormData({ profile_pictureLink: item.profile_picture }));

        // Buat objek baru tanpa profile_picture
        const { profile_picture, ...updatedItem } = item;
        dispatch(setFormData({
            ...updatedItem,
        }));

        history(`${process.env.PUBLIC_URL}/doctor/edit/${item.id}`);
    };




    return (
        <Fragment>
            <div className="product-wrapper-grid">
                <Row className="gridRow">
                    {doctors && doctors.map((item) => {
                        return (
                            <div id="gridId" className={`${layoutColumns === 3 ? 'col-xl-3 col-lg-6 col-sm-6 xl-4' : 'col-xl-' + layoutColumns}`} key={item.id}>
                                <Card >
                                    <div className="product-box">
                                        <div className="product-img" style={{ height: 'auto', overflow: 'hidden' }}>
                                            <Image attrImage={{ className: 'img-fluid w-100', src: item.profile_picture ? item.profile_picture : errorImg, alt: `${item.name}`, style: { height: '100%', objectFit: 'cover' } }} />
                                            <div className="product-hover">
                                                <UL attrUL={{ className: 'simple-list' }}>
                                                    <LI title="Delete" onClick={() => handleDelete(dispatch, item.id, setRefetch, deleteDoctor)}><Btn attrBtn={{ color: 'transprant', type: 'button', datatoggle: 'modal', datatarget: '#exampleModalCenter' }}><i className="icon-trash"></i></Btn> </LI>
                                                    <LI title="Edit" onClick= {() => handleEdit(item)}><Btn attrBtn={{ color: 'transprant', type: 'button' }}><i className="icon-pencil-alt"></i></Btn></LI>
                                                </UL>
                                            </div>
                                        </div>
                                        <div className="product-details">
                                            <H4>
                                                <span title={item.name} style={{ cursor: 'default', color: 'inherit', textTransform: 'none'  }}>
                                                    {item.name && item.name.length > 23 ? `${item.name.substring(0, 23)}...` : item.name}
                                                </span>
                                            </H4>
                                            <P><i className="icon-alarm-clock me-2"></i> 
                                                <Moment format="DD MMM YYYY, hh:mm:ss">
                                                    {item.created_at}
                                                </Moment>
                                            </P>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        );
                    })}
                </Row>
            </div>
        </Fragment>
    );
};
export default DoctorContent;